import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './themes.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import { initTheme } from './theme';

// Restore the saved theme before first paint.
initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

registerServiceWorker({
  // A new build is installed and waiting; UpdatePrompt asks the user to apply it.
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('civiccode:sw-update-available', { detail: { registration } }));
  },
  // Another tab applied the update; this tab is still running the old bundle.
  onExternalActivate: () => {
    window.dispatchEvent(new Event('civiccode:sw-activated-elsewhere'));
  },
});
